import {ChangeDetectorRef, Component} from '@angular/core';
import {AlertController, IonicPage, NavController, NavParams, Platform} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {ConfigurationThing} from "../../models/configurationThing";
import {VizixService} from "../../providers/vizix.service";
import {ReaderService} from "../../providers/reader.service";
import {MenuTrackerRetailPage} from "../menu-tracker-retail/menu-tracker-retail";
import {ReaderDevice} from "../../models/reader-model/readerDevice";
import {ReaderConnectionResponse} from "../../models/reader-model/readerConnectionResponse";
import {CycleCountService} from "../../providers/cyclecount.service";
import {Storage} from '@ionic/storage';
import {
  NAV_PARAM_CONFIGURATION_THING,
  NAV_PARAM_CONNECTED_TO_READER,
  NAV_PARAM_RETURN_PAGE,
  NAV_PARAM_SELECTED_READER,
  SPLASH_SCREEN_LOGS_ENABLED,
  STORAGE_CONFIGURATION_THING,
  STORAGE_READER_SOUND_LEVEL,
  VIZIX_EVENT_ID_READER_CONNECT,
  VizixEventAction,
  VizixEventActivity,
  VizixEventCategory,
  VizixEventEventType,
  VizixEventSubCategory
} from "../../app/app.constants";
import {TimeoutError} from "rxjs/Rx";
import {SimulatorService} from "../../providers/simulator.service";
import {ConfigurationService} from "../../providers/configuration.service";
import {VizixEventService} from "../../providers/vizix.event.service";
import {DeviceSelectPage} from "../device-select/device-select";
import {LoginPage} from "../login/login";
import {FindItemService} from "../../providers/find.item.service";
import {EncodeTagsService} from "../../providers/encode.tags.service";
import {EPCSequenceThingService} from "../../providers/epc.sequence.thing.service";

@IonicPage()
@Component({
  selector: 'page-splash',
  templateUrl: 'splash.html',
})
export class SplashPage {

  private tag = '[SPLASH]';

  listStatus: Array<string>;
  selectedReader: ReaderDevice;
  configurationThing: ConfigurationThing;
  connectToReader: string;
  connectionToReaderAttempts: number = 0;
  isExitAlertPresent: boolean = false;
  returnPage: string;

  public isLogsEnabled: boolean = false;
  public progress: number = 0;
  private isPopActive: boolean = false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              private _vizixService: VizixService,
              private platform: Platform,
              private alertCtrl: AlertController,
              public readerService: ReaderService,
              private cdr: ChangeDetectorRef,
              private cycleCountService: CycleCountService,
              private vizixEventService: VizixEventService,
              private findItemService: FindItemService,
              private encodeTagsService: EncodeTagsService,
              private epcSequenceThingService:EPCSequenceThingService,
              private storage: Storage,
              private simulatorService: SimulatorService,
              private configurationService: ConfigurationService) {
    this.connectToReader = this.navParams.get(NAV_PARAM_CONNECTED_TO_READER);
    this.selectedReader = this.navParams.get(NAV_PARAM_SELECTED_READER);
    this.configurationThing = this.navParams.get(NAV_PARAM_CONFIGURATION_THING);
    this.returnPage = this.navParams.get(NAV_PARAM_RETURN_PAGE);
    this.listStatus = [];
    this.isLogsEnabled = SPLASH_SCREEN_LOGS_ENABLED;
  }

  // First we get the configuration thing
  ionViewDidLoad() {
    // Step 1
    this.updateConfigurationThing();
  }

  ionViewDidEnter() {
    this.cdr.reattach();
    this.cdr.detectChanges();
  }

  ionViewWillEnter() {
    this.progress = 0;
    this.platform.registerBackButtonAction(() => {
      if (!this.isExitAlertPresent) {
        this.alertExitConfirm();
      }
    });
  }

  private updateConfigurationThing() {
    this.listStatus.push(this.translate.instant('splash.steps.init_update_config_thing'));

    let updateErrorAlert = this.alertCtrl.create({
      title: this.translate.instant('splash.alerts.error_update.title'),
      subTitle: this.translate.instant('splash.alerts.error_update.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('splash.alerts.error_update.cancel'),
          handler: () => {
            if (!this.isPopActive) {
              this.isPopActive = true;
              this.navCtrl.pop();
            }
          }
        },
        {
          text: this.translate.instant('splash.alerts.error_update.ok'),
          handler: () => {
            this.listStatus.push('Retrying Updating Configuration');
            this.updateConfigurationThing();
          }
        }
      ]
    });

    let updateValidationErrorAlert = this.alertCtrl.create({
      title: this.translate.instant('splash.alerts.error_update_validation.title'),
      subTitle: this.translate.instant('splash.alerts.error_update_validation.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('splash.alerts.error_update_validation.cancel'),
          handler: () => {
            if (!this.isPopActive) {
              this.isPopActive = true;
              this.navCtrl.pop();
            }
          }
        },
        {
          text: this.translate.instant('splash.alerts.error_update_validation.ok'),
          handler: () => {
            this.listStatus.push('Retrying Updating Configuration');
            this.updateConfigurationThing();
          }
        }
      ]
    });


    this._vizixService.VizixUpdateConfig(this._vizixService.configurationApp._id).subscribe((data: ConfigurationThing) => {
        let configurationError = this.configurationService.validateConfiguration(data);
        if (configurationError == "") {

          this.configurationService.fillDefaultValues(data);
          this.configurationThing = data;
          console.log(this.tag, 'Configuration Thing Updated', this.configurationThing);

          // Update in storage
          this.storage.set(STORAGE_CONFIGURATION_THING, this.configurationThing);

          this.listStatus.push(this.translate.instant('splash.steps.finish_update_config_thing'));
          this.init();

          //Configure simulator
          if (this.configurationThing.SimulatorConfiguration != null) {
            this.simulatorService.config(this.configurationThing.SimulatorConfiguration);
          }

          // Init upload pending CycleCounts once configuration thing was updated
          this.cycleCountService.init();
          // Init upload pending Events viewer
          this.vizixEventService.init();
          // Init FindItem db
          this.findItemService.init();

          // Init report definitions
          this._vizixService.VizixUpdateReportDefinitionIdentifyTag();

          // Init upload pending Encoded tags
          this.encodeTagsService.init();

          // Init upload pending EPCSequenceThing
          this.epcSequenceThingService.init();
        } else {
          updateValidationErrorAlert.setSubTitle(this.translate.instant('splash.alerts.error_update_validation.message') +
            configurationError);
          updateValidationErrorAlert.present();
        }
      },
      error => {
        updateErrorAlert.present();
      });
  }

  // Step 2
  private ConnectReader() {
    let timeOutErrorAlert = this.alertCtrl.create({
      title: this.translate.instant('splash.alerts.error_reader_connect.title'),
      subTitle: this.translate.instant('splash.alerts.error_reader_connect.messageTimeOut'),
      enableBackdropDismiss: false,
      buttons: [
        {
          //Cancel will select another reader
          text: this.translate.instant('splash.alerts.error_reader_connect.cancel'),
          handler: () => {
            if (!this.isPopActive) {
              this.isPopActive = true;
              this.navCtrl.popToRoot({animate: false}).then(() => {
                this.navCtrl.push(DeviceSelectPage);
              });
            }
          }
        },
        {
          text: this.translate.instant('splash.alerts.error_reader_connect.ok'),
          handler: () => {
            //Reconnect
            this.listStatus.push(this.translate.instant('splash.steps.reconnect_reader'));
            this.connectionToReaderAttempts++;
            this.setProgress(0);
            this.ConnectReader();
          }
        },
        {
          text: this.translate.instant('menu_tracker_retail.alerts.exit_or_logout.logout'),
          handler: () => {
            this.logOut();
          }
        }
      ]
    });


    let connectionErrorAlert = this.alertCtrl.create({
      title: this.translate.instant('splash.alerts.error_reader_connect.title'),
      subTitle: this.translate.instant('splash.alerts.error_reader_connect.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('splash.alerts.error_reader_connect.cancel'),
          handler: () => {
            if (!this.isPopActive) {
              this.isPopActive = true;
              this.navCtrl.pop();
            }
          }
        },
        {
          text: this.translate.instant('splash.alerts.error_reader_connect.ok'),
          handler: () => {
            this.listStatus.push(this.translate.instant('splash.steps.reconnect_reader'));
            this.connectionToReaderAttempts++;
            this.setProgress(0);
            this.ConnectReader();
          }
        },
        {
          text: this.translate.instant('menu_tracker_retail.alerts.exit_or_logout.logout'),
          handler: () => {
            this.logOut();
          }
        }
      ]
    });

    let connectionErrorMaxAttemptsAlert = this.alertCtrl.create({
      title: this.translate.instant('splash.alerts.error_reader_connect_max.title'),
      subTitle: this.translate.instant('splash.alerts.error_reader_connect_max.message'),
      enableBackdropDismiss: false,
      buttons: [{
          text: this.translate.instant('splash.alerts.error_reader_connect_max.cancel'),
          handler: () => {
            if (!this.isPopActive) {
              this.isPopActive = true;
              this.navCtrl.pop();
            }
          }
        },
        {
          text: this.translate.instant('splash.alerts.error_reader_connect_max.ok'),
          handler: () => {
            this.LoadDeptZones();
          }
        },
        {
          text: this.translate.instant('menu_tracker_retail.alerts.exit_or_logout.logout'),
          handler: () => {
            this.logOut();
          }
        }]
    });
    let readerTiltAlert = this.alertCtrl.create({
      title: this.translate.instant('splash.alerts.error_reader_tilt.title'),
      subTitle: this.translate.instant('splash.alerts.error_reader_tilt.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('splash.alerts.error_reader_tilt.ok'),
          handler: () => {
            if (!this.isPopActive) {
              this.isPopActive = true;
              this.navCtrl.pop();
            }
          }
        }]
    });

    console.log(this.tag, 'configuration to connect:');
    console.log(this.tag, this._vizixService.configurationApp.ReaderConfiguration.get());

    if (this.selectedReader) {
      this.listStatus.push(this.translate.instant('splash.steps.connect_reader'));
      this.readerService.connect(this.selectedReader, this._vizixService.configurationApp.ReaderConfiguration.get())
        .subscribe(
          (result: ReaderConnectionResponse) => {

            if (result.name) {
              // Done
              this.setProgress(80);

              this.generateAndSaveEvent(false);

              this.listStatus.push(this.translate.instant('splash.steps.connected_reader'));
              this.readerService.readerInformation = result;
              this.configureReaderSound();
            } else {
              // Partial
              console.log(this.tag, result);
              this.setProgress(this.progress + 20);
            }
          },
          (error) => {

            this.generateAndSaveEvent(true);

            this.listStatus.push(this.translate.instant('splash.steps.error_connect_reader'));
            if (this.connectionToReaderAttempts < this.configurationThing.ReaderConfiguration.ConnectionAttemptsMax.value) {
              if (error.code == 1002 || error.code == 1012 || error.code == 1010 || error.code == 0) {
                connectionErrorAlert.present();
              } else if (error.code == 1001) {
                connectionErrorMaxAttemptsAlert.present();
              } else if (error.code == 2034) {
                readerTiltAlert.present();
              }
              else if (error instanceof TimeoutError) {
                timeOutErrorAlert.present();
              }
            } else {
              connectionErrorMaxAttemptsAlert.present();
            }
          }
        );
    } else if (this.connectToReader) {
      this.listStatus.push(this.translate.instant('splash.steps.pairing_reader'));
      this.readerService.pairAndConnect(this.connectToReader, this._vizixService.configurationApp.ReaderConfiguration.get())
        .subscribe(
          (result: ReaderConnectionResponse) => {
            if (result.name) {
              this.listStatus.push(this.translate.instant('splash.steps.connected_reader'));
              this.readerService.readerInformation = result;
              this.configureReaderSound();
            }
          },
          (error) => {
            this.listStatus.push(this.translate.instant('splash.steps.error_connect_reader'));
            if (error.code == 1002 || error.code == 1012 || error.code == 1010) {
              connectionErrorAlert.present();
            } else if (error.code == 1001) {
              connectionErrorMaxAttemptsAlert.present();
            } else if (error instanceof TimeoutError) {
              timeOutErrorAlert.present();
            }
          }
        );
    }
  }

  // Step 2: No reader
  private LoadDeptZones(isRetry: boolean = false): void {
    let existsdefaultDept = false;
    let existsdefaultZone = false;

    this.listStatus.push(this.translate.instant('splash.steps.dept_zones_caching'));

    this._vizixService.VizixPostReportExecutionZones(isRetry).subscribe((data: boolean) => {
        if (!data && !isRetry) {
          this.LoadDeptZones(true);
          return;
        }

        let defaultDepartment = this._vizixService.configurationApp.AppParametersConfiguration.DefaultDepartment.value;
        let defaultZone = this._vizixService.configurationApp.AppParametersConfiguration.DefaultZone.value;

        this.listStatus.push(this.translate.instant('splash.steps.dept_zones_cached'));
        this.listStatus.push(this.translate.instant('splash.steps.dept_zones_validating'));
        console.log(this.tag, 'Default Department', defaultDepartment);
        console.log(this.tag, 'Default Zone', defaultZone);

        for (let dept of this._vizixService.zoneDeptList) {
          if (dept.DeptName == defaultDepartment) {
            existsdefaultDept = true;
            this.listStatus.push(this.translate.instant('splash.steps.default_dept_validated'));
            for (let zone of dept.Zones) {
              if (zone.zoneTypeCode == defaultZone) {
                existsdefaultZone = true;
                this.listStatus.push(this.translate.instant('splash.steps.default_zone_validated'));
                break;
              }
            }
            break;
          }
        }

        if (!existsdefaultDept || !existsdefaultZone) {
          if (!existsdefaultDept) {
            console.log(this.tag, 'Invalid Default department');
            this.listStatus.push(this.translate.instant('splash.steps.default_dept_invalid'));
          }
          if (!existsdefaultZone) {
            console.log(this.tag, 'Invalid Default zone');
            this.listStatus.push(this.translate.instant('splash.steps.default_zone_invalid'));
          }
          this.RetryLoadDeptZones(this.translate.instant('splash.alerts.retry_zone_dept.message.invalid'));
        } else {
          if (this.validateDefaultZoneDepartmentAssociationEncode()) {
            this.goToMainMenu();
          }
          else {
            this.RetryLoadDeptZones(this.translate.instant('splash.alerts.retry_zone_dept.message.invalid_association'));
          }
        }
      },
      (error) => {
        console.log(error);
        this.RetryLoadDeptZones(this.translate.instant('splash.alerts.retry_zone_dept.message.error'));
      }, () => {
      });
  }

  generateAndSaveEvent(isError: boolean) {
    this.vizixEventService.getVizixEventItemBase(isError).then((vizixEvent) => {
      vizixEvent.action = VizixEventAction.CONNECT;
      vizixEvent.category = VizixEventCategory.WORKFLOW;
      vizixEvent.subCategory = VizixEventSubCategory.READER;
      vizixEvent.eventType = VizixEventEventType.INFO;
      vizixEvent.eventId = VIZIX_EVENT_ID_READER_CONNECT;
      vizixEvent.activity = VizixEventActivity.READER_CONNECT;
      vizixEvent.detail = JSON.stringify(this.selectedReader);
      this.vizixEventService.recordEvent(vizixEvent);
    }, (error) => {
      console.log(this.tag, 'Error getting VizixItemBase', error);
    });
  }

  private RetryLoadDeptZones(msg): void {
    const isIos = this.platform.is('ios');
    let alert = this.alertCtrl.create({
      title: this.translate.instant('splash.alerts.retry_zone_dept.title'),
      message: msg,
      enableBackdropDismiss: false,
      buttons: [
        {
          text: !isIos ? this.translate.instant('splash.alerts.retry_zone_dept.cancel') : this.translate.instant('splash.alerts.retry_zone_dept.logout'),
          role: 'cancel',
          handler: () => {
            if (isIos) {
              this.logout();
            }
            else {
              this.platform.exitApp(); // TODO: ADD READER DISCONNECT
            }
          }
        },
        {
          text: this.translate.instant('splash.alerts.retry_zone_dept.ok'),
          handler: () => {
            this.LoadDeptZones();
          }
        }
      ]
    });
    alert.present();
  }

  // Step 2
  private init() {
    if (this.selectedReader || this.connectToReader) {
      this.setProgress(20);
      this.ConnectReader();
    } else {
      this.setProgress(50);
      this.LoadDeptZones();
    }
  }

  logOut() {
    this.logout();
  }

  alertExitConfirm() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('menu_tracker_retail.alerts.exit.title'),
      subTitle: this.translate.instant('menu_tracker_retail.alerts.exit.message'),
      buttons: [
        {
          text: this.translate.instant('menu_tracker_retail.alerts.exit.cancel'),
          role: 'cancel',
          handler: () => {
            this.isExitAlertPresent = false;
          }
        },
        {
          text: this.translate.instant('menu_tracker_retail.alerts.exit.ok'),
          handler: () => {
            this.isExitAlertPresent = false;
            this.logOut();
          }
        }
      ]
    });
    this.isExitAlertPresent = true;
    alert.present();
  }

  setProgress(progress: number) {
    this.progress = progress;
    this.cdr.detectChanges();
  }

  configureReaderSound() {
    this.readerService.setBeepSound(0).subscribe(() => {
      console.log(this.tag, 'Reader volume set to 0');
      this.setProgress(80);
      this.LoadDeptZones();
    }, () => {
      console.log(this.tag, 'Could not set reader volume to 0');
      this.setProgress(80);
      this.LoadDeptZones();
    });

    // If not set, create Sound Level = MAX = 10 in storage
    this.storage.get(STORAGE_READER_SOUND_LEVEL).then((levelSound) => {

      console.log(this.tag, 'Sound Level from storage', levelSound);

      if (!levelSound && levelSound != 0) {
        this.storage.set(STORAGE_READER_SOUND_LEVEL, 10);
      }
    });
  }

  goToMainMenu() {
    this.setProgress(95);
    let timeout = () => {
      this.setProgress(100);
      this.navCtrl.push(MenuTrackerRetailPage, {returnPage: this.returnPage});
    };
    setTimeout(timeout, 500);
  }

  validateDefaultZoneDepartmentAssociationEncode(): boolean {

    let defaultZone = this._vizixService.configurationApp.AssociationConfiguration.DefaultAssociationZone.value;
    let showZone = this._vizixService.configurationApp.AssociationConfiguration.ShowZonePickList.value;
    let existsDefaultZone = false;
    let defaultZoneEncode = this._vizixService.configurationApp.EncodeTagConfiguration.DefaultEncodeZone.value;
    let showZoneEncode = this._vizixService.configurationApp.EncodeTagConfiguration.ShowZonePickList.value;
    let existsDefaultZoneEncode = false;

    this.listStatus.push(this.translate.instant('splash.steps.dept_zones_validating'));
    console.log(this.tag, 'Default Association Zone', defaultZone);
    console.log(this.tag, 'Default Encode Zone', defaultZoneEncode);

    //validating Default Zone it must be valid if we not show the Zone
    for (let dept of this._vizixService.zoneDeptList) {
      for (let zone of dept.Zones) {
        if (zone.zoneTypeCode == defaultZone) {
          existsDefaultZone = true;
          this.listStatus.push(this.translate.instant('splash.steps.default_zone_validated'));
        }
        if (zone.zoneTypeCode == defaultZoneEncode) {
          existsDefaultZoneEncode = true;
          this.listStatus.push(this.translate.instant('splash.steps.default_zone_validated'));
        }
      }
    }
    if (!existsDefaultZone && !showZone) {
      this.listStatus.push(this.translate.instant('splash.steps.default_zone_invalid'));
      return false;
    }
    if (!existsDefaultZoneEncode && !showZoneEncode) {
      this.listStatus.push(this.translate.instant('splash.steps.default_zone_invalid'));
      return false;
    }

    return true;
  }


  setReaderDisconnected() {
    this.readerService.disconnect().subscribe(
      (response: any) => {
        console.log(this.tag, response);
        this.logOut();
      }, (error) => {
        this.logOut();
      }
    );
  }

  private logout() {
    this._vizixService.VizixLogOut().subscribe(() => {
      console.log(this.tag, 'LogOut success');
    }, (err) => {
      console.log(this.tag, 'Error LogOut', err);
    });
    this._vizixService.clearVizixService();
    this.storage.remove(STORAGE_READER_SOUND_LEVEL).then(() => {
      console.log(this.tag, 'Sound reader level Removed');
    }, (err) => {
      console.log(this.tag, 'Error removing Sound reader level', err);
    });
    if (!this.isPopActive) {
      this.isPopActive = true;
      this.navCtrl.popToRoot({animate: false}).then(() => {
        this.navCtrl.push(LoginPage);
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/splash/splash.ts